export default __webpack_public_path__ + "static/media/MPulse Software.789b6d6f.png";